<div class="row">
  <div class="col-md-12 text-right" style="margin-bottom: 10px;">
    <button (click)="abrirModalNovoDocumento()" class="btn btn-primary"><i class="fa fa-plus"></i> Cadastrar</button>
  </div>
  <div class="col-md-12">
    <div class="card card-blue">
      <div class="card-header">
        <h6 class="card-title" style="color: #ffffff">Lista de documentos</h6>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover table-striped text-nowrap table-sm">
          <thead>
            <tr>
              <th colspan="6" class="text-center" style="font-size: 16px;">Pastas de documentos</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let grupo of documentosAgrupados | paginate: { itemsPerPage: 10, currentPage: paginaAtual }">
              <tr (click)="togglePasta(grupo)" style="cursor: pointer; background-color: #f4f6f9;">
                <td colspan="6" style="font-size: 13px;">
                  <i class="fa" [ngClass]="grupo.aberta ? 'fa-folder-open' : 'fa-folder'"></i>
                  <strong class="ml-2"> {{grupo.pasta}} </strong>
                  <span class="badge badge-primary ml-2">{{grupo.documentos.length}} documentos</span>
                </td>
              </tr>
              <ng-container *ngIf="grupo.aberta">
                <tr style="font-size: 11px;background-color: #f8f9fa; font-weight: bold;">
                  <td style="padding-left: 30px;">Id</td>
                  <td>Arquivo</td>
                  <td>Processo</td>
                  <td>Extensão</td>
                  <td>Data</td>
                  <td style="width: 20px">*</td>
                </tr>
                <tr *ngFor="let item of grupo.documentos">
                  <td style="padding-left: 30px;">{{item.id}}</td>
                  <td>{{item.descricao}}</td>
                  <td>{{item.processo}}</td>
                  <td>{{item.extensao}}</td>
                  <td>{{item.dataCadastro | date: 'dd/MM/yyyy'}}</td>
                  <td>
                    <button (click)="baixarDocumento(item.id, item.descricao)" class="btn btn-info btn-xs mr-1" title="Download">
                      <i class="fa fa-download"></i>
                    </button>
                    <button (click)="removerDocumento(item.id)" class="btn btn-danger btn-xs" title="Remover">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
            <tr *ngIf="!documentosAgrupados || documentosAgrupados.length === 0">
              <td colspan="6" class="text-center text-orange">Nenhum registro a ser mostrado</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="text-center">
              <td colspan="6">
                <pagination-controls
                  class="pagination-sm"
                  [autoHide]="false"
                  [directionLinks]="true"
                  previousLabel="Anterior"
                  nextLabel="Próximo"
                  (pageChange)="pageChange($event)">
                </pagination-controls>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>

<app-novo-documento-processo [isModal]="true" (atualizarLista)="buscarListaDocumentoProcesso()"></app-novo-documento-processo>
